export enum PricingMethodType {
  STANDARD = 'STANDARD',
  CLASS_TYPE = 'CLASS_TYPE'
}
